import Loadable from "@loadable/component";

const TrackOrderPage = Loadable(
  () => import(/* webpackChunkName: "track_order_page" */ "./trackOrder")
);

export default TrackOrderPage;
